import { useAnalyticsDispatch } from '@context/AnalyticsContext';

export function useAnalytics() {
  return useAnalyticsDispatch();
}
